module.exports = __webpack_public_path__ + "static/media/mb5.4732ecaa.png";